import clsx from 'clsx';

type GetRoundedClassNameProps = {
  rowIndex?: number;
  columnIndex: number;
  columnsCount: number;
  rowsCount?: number;
};

export const getRoundedClassName = ({
  rowIndex = 0,
  rowsCount,
  columnIndex,
  columnsCount,
}: GetRoundedClassNameProps) => {
  // don't style first row in the table, only in header
  // header has rowsCount === undefined
  const firstRow = rowsCount === undefined && rowIndex === 0;
  const lastRow = rowsCount !== undefined && rowIndex === rowsCount - 1;

  const firstColumn = columnIndex === 0;
  const lastColumn = columnIndex === columnsCount - 1;

  if (!firstRow && !lastRow) return '';
  if (!firstColumn && !lastColumn) return '';

  return clsx(
    firstRow && firstColumn && 'rounded-tl-sm',
    firstRow && lastColumn && 'rounded-tr-sm',
    lastRow && firstColumn && 'rounded-bl-sm',
    lastRow && lastColumn && 'rounded-br-sm'
  );
};
